import React from 'react';
import { Row, Col } from 'bootstrap';
import StartTimeMixin from 'main/components/show/cuesheet/startTimeMixin';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import Duration from 'main/components/show/cuesheet.responsive/itemDuration.jsx';
import StartTime from 'main/components/show/cuesheet.responsive/itemStartTime.jsx';
import PresetDuration from 'main/components/show/cuesheet.responsive/itemPresetDuration.jsx';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import HighlightCellMixin from 'main/components/show/cuesheet/highlightCellMixin';
import ItemNumber from 'main/components/show/cuesheet.responsive/itemNumber.jsx';
import ItemTitle from 'main/components/show/cuesheet.responsive/itemTitle.jsx';
import ItemDescription from 'main/components/show/cuesheet.responsive/itemDescription.jsx';
import ItemCog from 'main/components/show/cuesheet.responsive/itemCog.jsx';
import ItemLock from 'main/components/show/cuesheet.responsive/itemLock.jsx';
import ItemNote from 'main/components/show/cuesheet.responsive/itemNote.jsx';
import ItemDataCell from 'main/components/show/cuesheet.responsive/itemDataCell.jsx';
import TrackingUserPill from 'main/components/show/cuesheet/itemCell/trackingUserPill';

import CueListItemMixin from 'main/components/show/cuesheet.responsive/cueListItemMixin.jsx';
import CueListItemTrackingMixin from 'main/components/show/cuesheet.responsive/cueListItemTrackingMixin.jsx';

import CuesheetHelper from 'flux/helpers/cuesheetHelper';
import CellHelper from 'main/components/show/cuesheet/cellHelper';

import Tappable from 'react-tappable';
import classNames from 'classnames';

const LoadingItem = () => {
  return <div className="csr-row-loading">Loading Row...</div>;
};

export default React.createClass({
  mixins: [
    StartTimeMixin,
    PureRenderMixin,
    HighlightCellMixin,
    CueListItemMixin,
    CueListItemTrackingMixin,
  ],

  getInitialState() {
    return { loading: true };
  },

  render() {
    const {
      isCopied,
      isTracked,
      isTitle,
      settings,
      cuesheetWidth,
      trackedUsers,
    } = this.props;

    if (this.state.loading) {
      return <LoadingItem />;
    }

    let className = classNames('csr-table-list-item', {
      'csr-list-item-copied': isCopied,
      'csr-list-item-tracked': isTracked,
      'csr-list-item-title': isTitle,
    });

    let itemWidthName = settings.getIn(['itemColumn', 'width']);

    if (!itemWidthName) itemWidthName = 'normal';
    const itemWidthType = ` csr-table-item-cell-width-${itemWidthName}`;

    const style = Object.assign(
      {},
      this.getGlobalHighlightStyle(),
      this.getPersonalHighlightStyle(),
    );

    return (
      <div className={className} style={{ minWidth: cuesheetWidth }}>
        <div
          style={style}
          className={'csr-table-cell csr-table-item-cell' + itemWidthType}
          ref={(e) => {
            if (e) this._item = e;
          }}
        >
          <div className="csr-item-cell">
            <TrackingUserPill trackedUsers={trackedUsers} />
            <div className="csr-item-settings">
              {this._getItemLockNode()}
              {this._getItemNumberNode()}
              {this._getItemCogNode()}
            </div>
            {this._getItemTitleNode()}
            {this._getItemDescriptionNode()}
            {this._getItemClockNodes(itemWidthName)}
          </div>
        </div>
        {this._getNoteCellNode()}
        {this._getColumnCellNodes()}
      </div>
    );
  },

  _getItemClockNodes(itemWidthName) {
    const {
      displayStartTime,
      displayPresetDuration,
      displayDuration,
    } = this.props;

    let startClock = (
      <div className="csr-table-item-start-time">
        {displayStartTime ? this._getItemStartTimeNode() : null}
      </div>
    );

    let presetClock = (
      <div className="csr-table-item-preset-dur">
        {displayPresetDuration ? this._getItemPresetDurationNode() : null}
      </div>
    );

    let durationClock = (
      <div className="csr-table-item-dur">
        {displayDuration ? this._getItemDurationNode() : null}
      </div>
    );

    if (itemWidthName === 'ultraNarrow') {
      return (
        <div className="csr-item-wrapper">
          <Row>
            <Col xs={24}>{startClock}</Col>
            <Col xs={24}>{presetClock}</Col>
            <Col xs={24}>{durationClock}</Col>
          </Row>
        </div>
      );
    }

    return (
      <Row>
        <Col xs={12}>
          {startClock}
          {presetClock}
        </Col>
        <Col xs={12}>{durationClock}</Col>
      </Row>
    );
  },

  _getItemCogNode() {
    return <ItemCog rowIndex={this.props.rowIndex} />;
  },

  _getItemLockNode() {
    return <ItemLock isLocked={this.props.item.get('locked')} />;
  },

  _getItemStartTimeNode() {
    return (
      <StartTime
        rowIndex={this.props.rowIndex}
        twentyFourHourClock={this.props.twentyFourHourClock}
        item={this.props.item}
      />
    );
  },

  _getItemPresetDurationNode() {
    let { presetDurationDisplayType, rowIndex, item } = this.props;

    return (
      <PresetDuration
        presetDurationDisplayType={presetDurationDisplayType}
        rowIndex={rowIndex}
        item={item}
      />
    );
  },

  _getItemDurationNode() {
    const { durationDisplayType, rowIndex, item } = this.props;

    return <Duration {...{ durationDisplayType, rowIndex, item }} />;
  },

  _getItemNumberNode() {
    let { itemNumberAdjusted, rowIndex } = this.props;

    return <ItemNumber itemNumber={itemNumberAdjusted} rowIndex={rowIndex} />;
  },

  _getItemTitleNode() {
    let { item, rowIndex } = this.props;

    return <ItemTitle item={item} rowIndex={rowIndex} />;
  },

  _getItemDescriptionNode() {
    const { item, displayDescription, rowIndex, rowId } = this.props;

    if (!displayDescription) return null;

    return (
      <ItemDescription
        item={item}
        rowIndex={rowIndex}
        rowId={rowId}
        placeholder="Description"
      />
    );
  },

  _getNoteCellNode() {
    let { hideNotes, item, userSettings, userId, rowIndex } = this.props;

    if (hideNotes) return null;

    let width = CuesheetHelper.getColumnWidth(
      userSettings.getIn(['noteColumn', 'width']),
    );

    const style = Object.assign(
      { width, minWidth: width },
      this.getGlobalHighlightStyle(),
      this.getPersonalHighlightStyle(),
      CellHelper.getFormatStyles(this._getCellFormat()),
    );

    return (
      <Tappable
        onTap={() =>
          CuesheetCellActions.startEditingItemCell(
            rowIndex,
            EditableCellTypes.ItemNote,
          )
        }
        className={'csr-table-cell csr-note-cell-parent'}
        style={style}
      >
        <ItemNote item={item} userId={userId} rowIndex={rowIndex} />
      </Tappable>
    );
  },

  _getUserSettings() {
    let { item } = this.props;
    return item.get('userSettings');
  },

  _getCellFormat() {
    let { userId } = this.props;

    let userSettings = this._getUserSettings();

    let path = [userId, 'note', 'format'];

    if (userSettings && userSettings.hasIn(path)) {
      return userSettings.getIn(path);
    }
  },

  _getColumnCellNodes() {
    let columns = this.props.columns;

    return columns.map(this._getColumnCellNode);
  },

  _getColumnCellNode(column) {
    let { item, rowIndex } = this.props;

    let format = item.getIn(['cells', column.get('_id'), 'format']);
    let columnId = column.get('_id');

    let width = CuesheetHelper.getColumnWidth(column.get('width'));

    const style = Object.assign(
      { width, minWidth: width },
      this.getGlobalHighlightStyle(),
      this.getPersonalHighlightStyle(),
      CellHelper.getFormatStyles(format),
    );

    return (
      <Tappable
        onTap={() =>
          CuesheetCellActions.startEditingDataCell(rowIndex, columnId)
        }
        className={'csr-table-cell'}
        style={style}
      >
        <ItemDataCell item={item} columnId={columnId} rowIndex={rowIndex} />
      </Tappable>
    );
  },

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
      this.forceUpdate(); //this will make us bypass shouldComponentUpdate
    }, 0);
  },
});
